import { ActionsUnion, createAction } from "store/helper";

import { IRequestFailure, RequestAction, createRequestTypes } from "../actions";

import { IApplication } from "./interfaces";

export const ApplicationsActionNames = {
  INSTALLED_APPS: createRequestTypes("ENTITIES/APPLICATIONS/INSTALLED"),
  PRIVATE_APPS: createRequestTypes("ENTITIES/APPLICATIONS/PRIVATE"),
  IN_REVIEW_APPS: createRequestTypes("ENTITIES/APPLICATIONS/IN_REVIEW"),
};

const installedAppsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInstalledApps: () => createAction(ApplicationsActionNames.INSTALLED_APPS[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInstalledAppsSuccess: (payload: IApplication[]) =>
    createAction(ApplicationsActionNames.INSTALLED_APPS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInstalledAppsFailure: (payload: IRequestFailure) =>
    createAction(ApplicationsActionNames.INSTALLED_APPS[RequestAction.FAILURE], payload),
};

const privateAppsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPrivateApps: () => createAction(ApplicationsActionNames.PRIVATE_APPS[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPrivateAppsSuccess: (payload: IApplication[]) =>
    createAction(ApplicationsActionNames.PRIVATE_APPS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPrivateAppsFailure: (payload: IRequestFailure) =>
    createAction(ApplicationsActionNames.PRIVATE_APPS[RequestAction.FAILURE], payload),
};

const inReviewAppsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInReviewApps: () => createAction(ApplicationsActionNames.IN_REVIEW_APPS[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInReviewAppsSuccess: (payload: IApplication[]) =>
    createAction(ApplicationsActionNames.IN_REVIEW_APPS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInReviewAppsFailure: (payload: IRequestFailure) =>
    createAction(ApplicationsActionNames.IN_REVIEW_APPS[RequestAction.FAILURE], payload),
};

export const ApplicationsActions = {
  ...installedAppsActions,
  ...privateAppsActions,
  ...inReviewAppsActions,
};

export type ApplicationsAction = ActionsUnion<typeof ApplicationsActions>;
